import { useCallback } from 'react';
import isNil from 'lodash/isNil';
import isString from 'lodash/isString';

import {
  UniversalFilterTextPlainValue,
  UniversalFilterTextPlainFilterState,
  UniversalFilterTextPlainOnChange
} from '../../UniversalFilterTextPlain.types';

interface UniversalFilterTextPlainFilterStateOptions {
  onChange: UniversalFilterTextPlainOnChange;
}

function useUniversalFilterTextPlainFilterState({
  onChange
}: UniversalFilterTextPlainFilterStateOptions) {
  // All modes and options available in handleApplyFilterState
  // must be implemented in handleParseFilterValue too
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterTextPlainFilterState) => void
  >(
    (filterState) => {
      const text = filterState?.text;

      if (text && isString(text)) {
        onChange(text);
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterTextPlainValue
    ) => UniversalFilterTextPlainFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (filterValue && isString(filterValue)) {
      return {
        text: filterValue
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterTextPlainFilterState;
